import React from 'react';

import { SortableContainer, SortableContainerProps } from 'react-sortable-hoc';

// eslint-disable-next-line import/namespace, import/no-cycle
import IfRule from './if.rule';
import StatementRule from './statement.rule';
import {
  Input, Rule,
} from '../../../../store/modules/rules';
import { useActions } from '../../../providers/actions-provider/actions.context';
import SecondaryButton from '../../../lib/secondary-button/secondary-button';

type IRulesContainerProps = SortableContainerProps & {
  rules: Rule[];
  level: number;
  // eslint-disable-next-line
  onChange: (value: any, rule: Rule, input: Input | null) => void,
  onStatementTypeChange: (type:string, rule: Rule) => void,
  target: string;
};

const RulesContainer = (
  {
    rules,
    level,
    onChange,
    onStatementTypeChange,
    target,
  }: IRulesContainerProps,
): JSX.Element => {
  const { ruleActions } = useActions();

  const renderRule = (rule: Rule, index: number) => {
    if (rule.name === 'if') {
      return (
        <IfRule
          key={`level_${level}_${rule.name}_${index}`}
          rule={rule}
          level={level + 1}
          onChange={onChange}
          onStatementTypeChange={onStatementTypeChange}
          index={index}
          target={target}
        />
      );
    }

    return (
      <StatementRule
        key={`${rule.name}_${index}`}
        rule={rule}
        onChange={onChange}
        onStatementTypeChange={onStatementTypeChange}
        index={index}
        target={target}
      />
    );
  };

  return (
    <div>
      <div style={{
        display: 'flex',
        justifyContent: 'flex-start',
        margin: '0px 4px',
        gap: '4px',
      }}
      >
        {
          target === 'systemConfig' || target === 'scheduledRules' ? null : (
            <SecondaryButton
              type="button"
              className="ant-btn--small"
              onClick={() => {
                ruleActions.addIfRule(rules, target);
              }}
            >
              Add if
            </SecondaryButton>
          )
        }
        <SecondaryButton
          type="button"
          className="ant-btn--small"
          onClick={() => {
            ruleActions.addStatementRule(rules, target);
          }}
        >
          Add statement
        </SecondaryButton>
      </div>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
      }}
      >
        {rules.map((r: Rule, index: number) => (renderRule(r, index)))}
      </div>
    </div>
  );
};

export default SortableContainer<IRulesContainerProps>(RulesContainer);
